/* eslint-disable camelcase */
export default function formatItemForWishListEvent({ ProductId, ProductClassId, Title, Price, ChildReportingCategory, ParentReportingCategory, IsSmartpak }) {
    const matches = Price.match(/\$(\d+.\d+)/gi);
    let price = '';

    if (Array.isArray(matches)) {
        price = matches.pop();
    }

    if (price.includes('$')) {
        price = parseFloat(price.replace('$', '')).toFixed(2);
    }

    return {
        item_name: Title,
        item_id: (ProductClassId + 10000).toString(),
        item_variant: ProductId.toString(),
        item_parent_reporting_category: ParentReportingCategory,
        item_child_reporting_category: ChildReportingCategory,
        item_autoship: 'no',
        item_smartpak: IsSmartpak ? 'yes' : 'no',
        price,
        quantity: '1'
    };
}